/** @format */

import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalController } from '@ionic/angular';
import { lastValueFrom } from 'rxjs';
import { ConfirmDialogComponent } from './confirm-dialog.component';

@Directive({
  selector: '[confirm]',
})
export class ConfirmDialogDirective {
  @Input('confirmTitle') title?: string;
  @Input('confirmMessage') message!: string;
  @Input('confirmValidate') validate?: string;
  @Input('confirmCancel') cancel?: string;
  @Input('yesLabelColor') yesLabelColor?: string;
  @Input('askForReason') askForReason?: boolean;
  @Input('reasonMandatory') reasonMandatory?: boolean;
  @Output() confirm = new EventEmitter<any>();
  @Output() canceld = new EventEmitter<void>();

  private dialogRef: MatDialogRef<ConfirmDialogComponent, any> | null;

  constructor(
    private dialog: MatDialog,
    private modalController: ModalController,
  ) {}

  @HostListener('click', ['$event']) async onClick(e: MouseEvent): Promise<void> {
    e.preventDefault();
    e.stopPropagation();

    if (this.dialogRef) return;

    await this.setTopIonicModalFocusTrapEnabled(false);

    try {
      this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
        data: {
          title: this.title,
          message: this.message,
          ok: this.validate,
          cancel: this.cancel,
          yesLabelColor: this.yesLabelColor,
          askForReason: this.askForReason ?? false,
          reasonMandatory: this.reasonMandatory ?? false,
        },
        minWidth: '400px',
        panelClass: 'dialog-confirm',
      });

      const data = await lastValueFrom(this.dialogRef.afterClosed());
      this.dialogRef = null;

      if (data) this.confirm.emit(data);
      else this.canceld.emit();
    } finally {
      await this.setTopIonicModalFocusTrapEnabled(true);
    }
  }

  private async setTopIonicModalFocusTrapEnabled(enabled: boolean): Promise<void> {
    const modal = await this.modalController.getTop();
    if (!modal) return;

    modal.classList.toggle('ion-disable-focus-trap', !enabled);
  }
}
